import React from 'react';
const INCLUDED_COLUMNS = [0,1,2,3,5,7,8,9,10];

const RankingsRow = ({row, rowKey}) => {
  return (
    <tr key={rowKey}>
        {row.map((col, i) => {
            return (
                INCLUDED_COLUMNS.includes(i) ?
                    <td key={i}>{col}</td>
                    :
                    <></>
            )
        })}
    </tr>
  )
};

export default RankingsRow;